<form id="inputForm" *ngIf="step$| async as step" [formGroup]="inputForm" (ngSubmit)="submit(step)" [hidden]></form>

<ng-container *ngIf="list$ | async as list">
  <ng-container *ngIf="list.length > 0">
    <ul>
      <li *ngFor="let file of list">
        <a [href]="serverUrl + file.path | safe:'url'" target="_blank">{{file.filename}}</a>
      </li>
    </ul>
  </ng-container>
</ng-container>

<object *ngIf="pdf$ | async as pdf" [data]="serverUrl + pdf.path | safe:'resourceUrl'" type="application/pdf"
  width="100%" height="440px">
